// extracted by mini-css-extract-plugin
module.exports = {"container":"A1itb","inner":"V0uMa","morphing_tabletLarge":"fMtKR","width_narrow":"h2xZW"};